<template>
    <v-container fluid class="container-full-bg-gray">
        <app-page-card>
            <template #header>
                {{ title }}
            </template>
            <template>
                <app-row>
                    <app-col>
                        <data-table-with-api
                            ref="registersTable"
                            :headers="registersHeaders"
                            :url="'async_command_bus/'"
                            :api_params="{ command: { cmd_name: 'get.access.registers', user_id: userData.user, offset: undefined, limit: undefined} }"
                            :footer-items-per-page-text="registersItemsPerPageText"
                            :search-filters="[]"
                            :showSelect="false"
                        >
                        </data-table-with-api>
                    </app-col>
                </app-row>
            </template>
        </app-page-card>
    </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DataTableWithApi from '../components/DataTableWithApi.vue'
import AppPageCard from '@/components/layout/AppPageCard.vue';
import AppRow from '@/components/layout/AppRow.vue';
import AppCol from '@/components/layout/AppCol.vue';
import { user } from '@/api/user';


export default {
    name: 'AccessRegistersList',
    components: {
        DataTableWithApi,
        AppPageCard,
        AppRow,
        AppCol,
    },
    data() {
        return {
            title: 'Registro de acceso',
            loadingAction: false,
            registersHeaders: [
                {
                    text: 'Nombre',
                    value: 'username',
                    sortable: false,
                    align: 'start',
                },
                {
                    text: 'Dirección',
                    value: 'email',
                    sortable: false,
                },
                {
                    text: 'Funcionalidad',
                    value: 'action',
                    sortable: false,
                },
                {
                    text: 'Fecha',
                    value: 'date',
                    sortable: false,
                },
                {
                    text: 'Empresa',
                    value: 'companyDBName',
                    sortable: false,
                },
                {
                    text: 'Dirección IP',
                    value: 'ip',
                    sortable: false,
                },
            ],
            registersItemsPerPageText: 'Registros por página:',
        }
    },
    computed: {
        ...mapGetters({
            userData: 'me/userData',
            permission: 'permissions/permission',
        }),
        getActions() {
            return {};
        },
    },
    methods: {
        ...mapActions({
            refreshUserData: "me/refreshUserData",
        }),
    },
}
</script>